import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { ConfigApiError } from './config.errors';
import { Config } from './models/config.model';
import { ConfigTask, DeployPreviewConfigTask } from './config.service';
import { ProjectSummary } from '../project/models/project-summary.model';

export const SetCurrentConfig = createAction(
  '[Config] Set Current Config',
  props<{ config: Config }>(),
);

export const LoadConfig = createAction('[Config] Load Config', props<{ configId: number }>());

export const LoadConfigSchema = createAction('[Config] Load Schema');

export const LoadConfigSchemaSuccess = createAction(
  '[Config] Load Schema Success',
  props<{ payload: any }>(),
);

export const LoadConfigSchemaFailed = createAction(
  '[Config] Load Schema Failed',
  props<{ error: ConfigApiError }>(),
);

export const LoadLatestConfigForProject = createAction(
  '[Config] Load Latest For Project',
  props<{ projectId: number }>(),
);

export const LoadDeployedConfigForProject = createAction(
  '[Config] Load Deployed Config For Project',
);

export const SetLoadConfigError = createAction(
  '[Config] Set Load Config Error',
  props<{ error: ConfigApiError }>(),
);

export const CreateConfigWithOptionalDeploySucceeded = createAction(
  '[Config] Create Config With Optional Deploy Succeeded',
  props<{ config: Config; deploy: boolean; redirect: string }>(),
);

export const CreateConfigSkipped = createAction(
  '[Config] Create Config Skipped',
  props<{ deploy: boolean; redirect: string }>(),
);

export const SetCreateConfigError = createAction(
  '[Config] Set Create Config Error',
  props<{ error: ConfigApiError }>(),
);

export const DeployConfig = createAction(
  '[Config] Deploy Config',
  props<{
    config: Config;
    keyName: string;
    // Todo: unused value in the action
    deployType?: string;
  }>(),
);

export const SetDeployConfigError = createAction(
  '[Config] Set Deploy Config Error',
  props<{ error: ConfigApiError }>(),
);

export const SetAvatar = createAction('[Config] Set Avatar', props<{ avatarName: string }>());

export const ResetAvatar = createAction('[Config] Reset Avatar');

export const RemoveConfigError = createAction('[Config] Remove Error');

export const DeployConfigSucceeded = createAction(
  '[Config] Deploy Config Succeeded',
  props<{ redirect: string }>(),
);

export const DeployConfigSkipped = createAction(
  '[Config] Deploy Config Skipped',
  props<{ redirect: string }>(),
);

export const DeployPreviewConfigStarted = createAction(
  '[Config Effect] Deploy Preview Config Started',
  props<{ task: DeployPreviewConfigTask }>(),
);

export const DeployPreviewConfigSucceeded = createAction(
  '[Config Effect] Deploy Preview Config Succeeded',
  props<{
    jwt: string;
  }>(),
);

export const DeployPreviewConfigErrored = createAction(
  '[Project Preview Effect] Deploy Preview Config Errored',
  props<{ error: ConfigApiError }>(),
);

export const LoadMediaAssetCreatorConfigSucceeded = createAction(
  '[Config Effect] Load Media Asset Creator Config Succeeded',
  props<{ config: Config }>(),
);

export const LoadMediaAssetCreatorConfigErrored = createAction(
  '[Config Effect] Load Media Asset Creator Config Errored',
  props<{ error: ConfigApiError }>(),
);

export const DeployMediaAssetCreatorConfigStarted = createAction(
  '[Config Effect] Deploy Media Asset Creator Config Started',
  props<{ task: DeployPreviewConfigTask }>(),
);

export const DeployMediaAssetCreatorConfigSucceeded = createAction(
  '[Config Effect] Deploy Media Asset Creator Config Succeeded',
  props<{
    jwt: string;
  }>(),
);

export const DeployMediaAssetCreatorConfigErrored = createAction(
  '[Config Effect] Deploy Media Asset Creator Config Errored',
  props<{ error: ConfigApiError }>(),
);

export const ConfigActions = createActionGroup({
  source: 'Config',
  events: {
    'Undeploy Clicked': props<{ projectSummary: ProjectSummary }>(),
    'Undeploy Confirmation Clicked': props<{ deployedConfigId: number; projectId: number }>(),
    'Undeploy Cancellation Clicked': emptyProps(),
  },
});

export const ConfigEffectActions = createActionGroup({
  source: 'Config Effect',
  events: {
    'Undeploy Processing': props<{ task: ConfigTask; projectId: number }>(),
    'Undeploy Succeeded': props<{ projectId: number }>(),
    'Undeploy Errored': props<{ error: ConfigApiError }>(),
  },
});
